'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var React = require('react');
var IconBase = require('@ali/vu-icon-base');

function Clear(props) {
  return React.createElement(
    IconBase,
    _extends({ viewBox: '0 0 1024 1024' }, props),
    React.createElement('path', { d: 'M557.248 512l158.56-158.528a31.904 31.904 0 0 0-0.16-45.12 31.808 31.808 0 0 0-45.12-0.16L512 466.752 353.472 308.16a31.904 31.904 0 0 0-45.12 0.16 31.808 31.808 0 0 0-0.16 45.12L466.752 512 308.16 670.528a31.904 31.904 0 0 0 0.16 45.12 31.808 31.808 0 0 0 45.12 0.16L512 557.248l158.528 158.56a31.904 31.904 0 0 0 45.12-0.16 31.808 31.808 0 0 0 0.16-45.12L557.248 512zM512 960C264.576 960 64 759.424 64 512S264.576 64 512 64s448 200.576 448 448-200.576 448-448 448z' })
  );
}
Clear.displayName = 'Clear';

module.exports = Clear;


//////////////////
// WEBPACK FOOTER
// ./~/_@ali_ve-icons@4.1.6@@ali/ve-icons/build/svglib/clear.js
// module id = 160
// module chunks = 0